import React from 'react';
import { useNavigate } from 'react-router-dom';
import { usePageTitle } from '../hooks/usePageTitle';

const SEOOptimalisatie: React.FC = () => {
  const navigate = useNavigate();
  usePageTitle('SEO Optimalisatie');

  return (
    <div className="min-h-screen">
      {/* Header Section */}
      <div
        className="relative py-20"
        style={{
          backgroundImage: `url('/hero-background.webp')`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      >
        <div className="container mx-auto px-8">
          <button
            onClick={() => navigate('/')}
            className="mb-6 text-white hover:text-orange-400 flex items-center transition"
          >
            <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
            </svg>
            Terug naar Home
          </button>
          <h1 className="text-5xl font-bold text-white mb-4">SEO Optimalisatie</h1>
          <p className="text-xl text-white/90 max-w-3xl">
            Word gevonden in Google en vergroot je online bereik
          </p>
        </div>
      </div>

      {/* Content Section */}
      <div className="container mx-auto px-8 py-16">
        <div className="max-w-4xl mx-auto">
          {/* Introduction */}
          <section className="mb-12">
            <h2 className="text-3xl font-bold text-blue-900 mb-6">Zichtbaar in zoekmachines</h2>
            <p className="text-lg text-gray-700 mb-4">
              Een mooie website is niets waard als niemand hem kan vinden. SEO (Search Engine Optimization)
              zorgt ervoor dat jouw website bovenaan verschijnt in Google wanneer potentiële klanten naar
              jouw diensten zoeken. Bij SnapLogic helpen we je om organisch verkeer te genereren en je
              online zichtbaarheid te vergroten.
            </p>
          </section>

          {/* What is SEO */}
          <section className="mb-12">
            <h2 className="text-3xl font-bold text-blue-900 mb-6">Wat is SEO?</h2>
            <div className="bg-blue-50 p-8 rounded-xl mb-6">
              <p className="text-gray-700 text-lg mb-4">
                SEO is het proces van het optimaliseren van je website zodat deze beter scoort in de
                organische zoekresultaten van Google. Dit omvat technische verbeteringen en content
                optimalisatie voor betere vindbaarheid.
              </p>
              <div className="grid md:grid-cols-3 gap-4 mt-6">
                <div className="text-center">
                  <div className="text-4xl mb-2">📈</div>
                  <p className="font-semibold">Meer bezoekers</p>
                </div>
                <div className="text-center">
                  <div className="text-4xl mb-2">💰</div>
                  <p className="font-semibold">Lagere kosten</p>
                </div>
                <div className="text-center">
                  <div className="text-4xl mb-2">🎯</div>
                  <p className="font-semibold">Betere targeting</p>
                </div>
              </div>
            </div>
          </section>

          {/* CTA */}
          <section className="bg-blue-900 text-white p-8 rounded-xl text-center">
            <h2 className="text-3xl font-bold mb-4">Klaar om te groeien in Google?</h2>
            <p className="text-xl mb-6">
              Laat ons je website naar de top van Google brengen
            </p>
            <button
              onClick={() => navigate('/?step=1')}
              className="px-8 py-3 rounded-lg font-bold transition transform hover:scale-105"
              style={{
                background: 'radial-gradient(circle at center, #ff8a3d 0%, #f06c28 45%, #d4551b 100%)',
              }}
            >
              Vraag SEO advies aan
            </button>
          </section>
        </div>
      </div>
    </div>
  );
};

export default SEOOptimalisatie;
